// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

const CustomBlock = (props) => {

    return (
        <div
            className={`${props.className ? props.className : ""}`}
            style={props.style}
        >
            {props.children}
        </div>
    );
}

CustomBlock.propTypes = {
    // MAIN PROPS
    className: PropTypes.string,
    style: PropTypes.object,
}

export default CustomBlock;